import { RootState } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";
import { isExperienceMultiCurrencyExperience } from "@src/store/slices/experiences/selectors/currency/isMultiCurrencyExperience";
import { Experience } from "@src/store/slices/experiences/types";

export const isMultiCurrencyTest = (state: RootState) => {
  const experience = selectedExperience(state);
  if (!experience) return false;

  return isExperienceMultiCurrencyTest(experience)(state);
};

export const isExperienceMultiCurrencyTest =
  (experience: Experience) => (state: RootState) => {
    return (
      experience.category === "experiment" &&
      isExperienceMultiCurrencyExperience(experience)(state)
    );
  };
